import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from 'html-react-parser';
import { parseMarginPadding, parseResult, parseItemResult } from '../controlUtils';
import { darkenHex } from "../colorUtils";
import { efWordByWord } from "../effectUtils";

export function displayInputUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const presentation = obj.Presentation;
    const mp = parseMarginPadding(content.MarginPadding);

    const params = {
        obj: obj,
        entryPoint,
        content,
        presentation,
        mp
    }

    let input = <></>;

    if(obj.ComponentType == "text"){
        input = text(params);
    }
    else if(obj.ComponentType == "html"){
        input = html(params);
    }
    else if(obj.ComponentType == "code"){
        input = code(params);
    }
    else if(obj.ComponentType == "note"){
        input = note(params);
    }
    else if(obj.ComponentType == "video"){
        input = youtubeVideo(params);
    }

    return parseResult(input, obj, entryPoint);
}

function text(params){

    const entryPoint = params.entryPoint;
    const title = params.content.Title;
    const value = params.content.Value; 
    const theme = params.content.Theme;
    const size = params.content.Size;
    const presentation = params.presentation;
    const mp = params.mp;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    if(entryPoint == "presentation" && presentation != ""){
        const ptn = JSON.parse(presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        container:{
            background: bgColor,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            borderRadius: 5
        },
        title:{
            color: txtColor,
            fontSize: titleSz,
            fontWeight: 600
        },
        text:{
            color: txtColor,
            fontSize: textSz,
        },
    }

    return (
        <div style={styles.container}>
            {(value.Title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <p style={styles.text} className={"text"}>
                {value != "" && efWordByWord(parse(value), 5)}
            </p>
        </div>
    )
}

function html(params){

    const entryPoint = params.entryPoint;
    const title = params.content.Title;
    const value = params.content.Value; 
    const theme = params.content.Theme;
    const size = params.content.Size;
    const presentation = params.presentation;
    const mp = params.mp;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    if(entryPoint == "presentation" && presentation != ""){
        const ptn = JSON.parse(presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        container: {
            flex: 1,
            background: bgColor,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            borderRadius: 5
        },
        title:{
            color: txtColor,
            fontSize: titleSz,
            fontWeight: 600
        },
        text:{
            fontSize: textSz,
        }
    }

    return (
        <div style={styles.container}>
            {(value.Title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <pre className={"html-script"}>
                <code style={styles.text} >
                    {value != "" && efWordByWord(parse(escapeHTMLTags(value)), 5)}
                </code>
            </pre>
        </div>
    )
}

function code(params){

    const entryPoint = params.entryPoint;
    const title = params.content.Title;
    const value = params.content.Value; 
    const theme = params.content.Theme;
    const size = params.content.Size;
    const presentation = params.presentation;
    const mp = params.mp;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    if(entryPoint == "presentation" && presentation != ""){
        const ptn = JSON.parse(presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        container: {
            flex: 1,
            background: bgColor,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            borderRadius: 5
        },
        title:{
            color: txtColor,
            fontSize: titleSz,
            fontWeight: 600
        },
        text:{
            fontSize: textSz,
        }
    }

    return (
        <div style={styles.container}>
            {(value.Title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <pre className={"code-script"}>
                <code style={styles.text}>
                    {value != "" && efWordByWord(parse(escapeHTMLTags(value)), 5)}
                </code>
            </pre>
        </div>
    )
}

function note(params){

    const obj = params.obj;
    const entryPoint = params.entryPoint;
    const title = params.content.Title;
    const value = params.content.Value; 
    const theme = params.content.Theme;
    const size = params.content.Size;
    const presentation = params.presentation;
    const mp = params.mp;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const dbgColor1 = (bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 20);
    const dbgColor2 = (bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 50);

    let bulbSz = 0; let bulbTop = 0; let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ 
        bulbSz = 36; 
        bulbTop = -20;
        titleSz=20; 
        textSz=16 
    }
    else if(size == "medium"){ 
        bulbSz = 46; 
        bulbTop = -25;
        titleSz=24; 
        textSz=18 
    }
    else if(size == "large"){ 
        bulbSz = 56; 
        bulbTop = -30;
        titleSz=34; 
        textSz=24 
    }

    if(entryPoint == "presentation" && presentation != ""){
        const ptn = JSON.parse(presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        container: {
            flex: 1,
            background: bgColor,
            minWidth: 360,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            border: `1px solid ${dbgColor1}`,
        },
        bulb:{
            color: dbgColor2,
            top: bulbTop,
            fontSize: bulbSz
        },
        title: {
            color: txtColor,
            marginTop: 10,
            fontSize: titleSz,
            fontWeight: 600
        },
        text: {
            color: txtColor,
            marginTop: 10,
            fontSize: textSz
        }
    }

    return (
        <div style = {styles.container} className = {"note"}>
            <FontAwesomeIcon icon={faLightbulb} style={styles.bulb} className='icon' />
            {(value.Title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <div style={styles.text} className = "text">
                {value != "" && efWordByWord(parse(value), 5)}
            </div>
        </div>
    )
}

function youtubeVideo(params){

    const entryPoint = params.entryPoint;
    const title = params.content.Title;
    const value = params.content.Value; 
    const theme = params.content.Theme;
    const size = params.content.Size;
    const presentation = params.presentation;
    const mp = params.mp;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; }
    else if(size == "medium"){ titleSz=24; }
    else if(size == "large"){ titleSz=34; }

    if(entryPoint == "presentation" && presentation != ""){
        const ptn = JSON.parse(presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        container: {
            flex: 1,
            minWidth: 400,
            maxWidth: 800,
            background: bgColor,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            borderRadius: 5
        },
        title:{
            color: txtColor,
            fontSize: titleSz
        },
        iframe: {
            border: 'none',
            borderRadius: 5,
        }
    }

    const src = value.replace("/watch?v=", "/embed/");

    return (
        <div style = {styles.container}>
            {(title != "") &&
                <h4 style = {styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <iframe src={src} className={"video"} style={styles.iframe}></iframe>
        </div>
    )
}

function escapeHTMLTags(htmlString) {
    return htmlString.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}